/// <reference path="../../advisor-module/views/advisor-app.ts" />
namespace advisorop.components.common {

    class AssignAdvisorInvestorController {
        $router;
        user: domains.identity.IUser;
        currentAdvisor: domains.IAdvisor;
        advisors: Array<domains.IInvestorAdvisor> = [];
        investor: domains.IInvestor;
        investorId: number;
        onCancelClicked: any;
        onAssignedAdvisor: any;
        advisorSelected: boolean = false;

        static $inject = ["advisorService", "identityService"];
        constructor(private advisorService: services.AdvisorService, private identityService: services.IdentityService) {

          
        }

        collapseVar: boolean = false;

        collapse(): void {
            this.collapseVar = false;
            this.advisorSelected = false;
            this.onCancelClicked({ editSate: false });
        }

        

        advisoryType: number = 0;

        newAdvisorSelected(advisor: domains.IAdvisor): void {
            if (advisor && advisor.id > 0)
                this.advisorSelected = true;

            var adv = this.advisors.filter((v, i, a) => {
                return (v.advisor.id == advisor.id);
            });
            if (adv.length === 0) {
                let advisorRelation: domains.IInvestorAdvisor = { advisor: advisor, relationType: this.advisoryType, investorId: this.investorId, relationTypeDescription: this.advisoryType == 0 ? 'Primary' : 'Secondary' };
                this.advisors.push(advisorRelation);
            }
            else
                toastr.warning("Advisor already exists in the list of advisors.");

        };

        //Assign advisors for individual
        //advisorAssigned: boolean = false;

        assignAdvisorsForInvestor(): void {

            // view model separates advisors between primary and secondary, split them out here for the API call
            this.investor.advisors = this.advisors.filter(a => a.relationType == domains.RelationType.PRIMARY);
            this.investor.secondaryAdvisors = this.advisors.filter(a => a.relationType == domains.RelationType.SECONDARY);

            //var acc = this.accounts.find(a => a.accountId == e.model.item.key);

            this.advisorService.updateAdvisorInvestor(this.investor)
                .success((data) => {
                   
                    toastr.success("Advisor assignment successfully updated.");
                    this.onCancelClicked({ editSate: this.collapseVar });
                    // this.advisorAssigned = true;

                    this.onAssignedAdvisor({ assigned: true });

                    this.investor.id = data.id;
                    this.advisorSelected = false;
                  
                })
                .error((data, status) => {
                    toastr.error("Error " + status + " : " + data);
                })
                .finally(() => {
               //     this.updatingAccountLadda = false;
                });
        }





        //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$


        //When Select individual this method should be triggered to load individual data

        loadAdvisorsForInvestor(inv: number): void {
            this.advisorService.getAdvisorsForInvestor(inv)
                .then(data => {
                    this.advisors = data.data;

                })
                .catch(err => {
                    toastr.error("Cannot load advisor " + err.status + " " + err.data);
                })
        }



        //############################################################################

        loadInvestor(investorId: number): void {
            this.advisorService.getInvestor(investorId)
                .then((data) => {
                    this.investor = data.data;
                    //console.log("Investor on load");
                    //console.log(this.investor);
                })
                .catch((reason) => {
                    console.log("Error during load individual");
                   // console.log(reason);
                });
        }

        removeAdvisorFromAdvisors(advisor: domains.IInvestorAdvisor): void {

            this.advisorSelected = true;
            var ind = this.advisors.indexOf(advisor);
            if (ind >= 0)
                this.advisors.splice(ind, 1);

        };

        loadedAdvisors: Array<domains.IInvestorAdvisor> = [];

        okToUpdate(): boolean {
            if (this.user) {
                return (this.user.systemLoginType == domains.SystemLoginType.ADVISOR && this.user.role == domains.AdvisoryRoles.ADVISORY_ADMIN.toString());
            } else {
                return false;
            }
        }

        $onInit(): void {
            this.identityService.getUserPromise().then(response => {
                this.user = response;
                this.currentAdvisor = this.user.advisor;
          
            });
          
        }

        createCase: boolean;

        $onChanges(evt): void {
 
            for (var key in evt) {
               
                if (key === "investorId") {
                    if (this.investorId > 0) {
                        this.loadInvestor(this.investorId);
                    }
                }
                if (key === "advisors") {
                    if (this.advisors.length > 0) {
                        this.advisors = this.advisors;
                    }
                }
                if (key === "advisorSelected") {
                    if (this.advisorSelected = false) {
                        this.advisorSelected = true;
                    }
                }
             
            }
        }




    }

    class AssignAdvisorInvestor implements ng.IComponentOptions
    {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.controller = AssignAdvisorInvestorController;
            this.controllerAs = "vm";
            this.bindings = {
                "$router": "<",
                investorId: "<",
                onCancelClicked: "&",
                advisors: "=",
                createCase: "<",
                onAssignedAdvisor: "&",
                advisorSelected: "="
                //resetFormAfterPost: "@",
                //investorCreated: "&"
            };
            this.templateUrl = "spa/shared/common/assign-advisor-investor.html";
        }

    }
    angular.module(Constants.APP).component("assignAdvisorInvestor", new AssignAdvisorInvestor());
    
}